
	import Component from 'vue-class-component'
	import moduleStore from './store/magicService';
	import Vue from 'vue';
	import PageState from './store/state';


	/**components**/
	@Component({})
	@moduleStore.initVuex({
		mutationNames:moduleStore.mutationNames,
		actionNames:moduleStore.actionNames
	})
	export default class magicServicePage extends Vue implements IvuePage<PageState>{
		state = new PageState();
		self:Vue = this;
		// service?: service;
		// controller?: controller;
		created(moduleData:IinjectDatas) {
			document.title = "官方客服"
			this.state = <PageState>moduleData.state;

			let query = this.$route.query
			this.state.serviceWechat = query.serviceWechat
		}
		mounted(moduleData:IinjectDatas){
			/*this.$http("getDataList",{}).then((response:any)=>{
				console.log(response)
			}).catch((ex:any)=>{
				console.log(ex)
			})*/
	
			this.state.title="这是更改后的title"
			this.state.self = this;
		}
	
	}